import { createFileRoute } from '@tanstack/react-router';
import { DataIndexIndexRedirect } from '@/pages/workspaces/data-index/routing';
import { LastWorkspaceResolver } from './-route-helpers';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/data-index/')({
  component: () => (
    <LastWorkspaceResolver>
      <DataIndexIndexRedirect />
    </LastWorkspaceResolver>
  ),
});
